<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>

        <div class="col-lg-10">
           <br>
            <div class="row">
                <div class="col-lg-4">
                    <span class="bold">Agregar Fotos:</span><br>
                    <input 
                    formControlName="file"
                    id="file" 
                    type="file" 
                    multiple
                    class="form-control"
                    (change)="onFileChange($event)"><br>
                    <!-- <input type="text" placeholder="Nombre Foto" [(ngModel)]="foto.nombre" class="form-control"> -->
                </div>
                <div class="col-lg-4">
                    <br>
                    <button class="btn btn-success" (click)="agregarFotos();">Agregar</button>
                </div>
                <div class="col-lg-4"></div>
            </div>

            <br><br>
            <div class="row">
                <div class="col-lg-3" *ngFor="let foto of fotos">
                    <img src="{{environment}}{{foto.imagen}}" width="100%"><br><br>
                    <div class="row">
                        <div class="col-lg-6">
                            <button class="btn btn-danger" (click)="eliminarFotoGrupo(foto.id);">Eliminar</button><br><br>
                        </div>
                        <div class="col-lg-6">
                            <p class="center">
                                <button class="btn btn-success" (click)="descargarImagen(foto.imagen)">Descargar</button>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
</div>